import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Layout from './components/Layout';
import CalculationTypes from './components/CalculationTypes';
import CalculationDetails from './components/CalculationDetails';
import UserInfo from './components/UserInfo';
import Calculator from './components/Calculator';
import './styles/style.css';
// import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path="/calculate"
            element={
              <Layout>
                <CalculationTypes />
              </Layout>
            }
          />
          <Route
            path="/details/:type"
            element={
              <Layout>
                <CalculationDetails />
              </Layout>
            }
          />
          <Route
            path="/user-info/:type"
            element={
              <Layout>
                <UserInfo />
              </Layout>
            }
          />
          <Route
            path="/calculate/:type"
            element={
              <Layout>
                <Calculator />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <Contact />
              </Layout>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;